import { ComponentProps } from "react";
import "./index.scss";

interface ActionButtonProps extends ComponentProps<"button"> {
  icon?: React.ReactNode;
  label: string;
  textColor?: string;
}

export const ActionButton = ({
  icon,
  label,
  textColor,
  style,
  className,
  ...props
}: ActionButtonProps) => {
  const buttonClassName = textColor
    ? `${className || ""} action-button-custom-color`
    : className || "";

  const buttonStyle = textColor
    ? ({ ...style, "--custom-text-color": textColor } as React.CSSProperties)
    : style;

  return (
    <button
      id="action-button"
      className={`btn btn-sm text-muted p-0 ${buttonClassName}`}
      title="Salvar"
      style={buttonStyle}
      {...props}
    >
      {icon && icon} {label}
    </button>
  );
};
